//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'

import FilesGroup from '../../../../../components/File/FilesGroup.js'
import ReadonlyDocumentsField from '../../../../../components/File/ReadonlyDocumentsField.vue'
import ReportCheckListOutlayRecord from './ReportCheckListOutlayRecord.vue'
import { convertTime } from '../../../../../components/helpers.js'

export default {
  components: {
    ReadonlyDocumentsField
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      convertTime: convertTime,
      columns: [
        {
          name: 'number',
          label: 'Номер',
          align: 'left',
          field: (row) => {
            return this.resultValue.value.indexOf(row) + 1
          },
          sortable: true,
          style: 'width: 50px',
          headerStyle: 'width: 50px'
        },
        {
          name: 'name',
          label: 'Наименование',
          align: 'left',
          field: 'toolTypeName',
          sortable: true
        },
        {
          name: 'amount',
          label: 'Количество',
          align: 'left',
          field: 'toolTypeAmount',
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: 'toolTypeUnit',
          sortable: true
        },
        {
          name: 'comment',
          label: 'Комментарий',
          align: 'left',
          field: 'comment',
          sortable: true
        },
        {
          name: 'photo',
          label: 'Фотографии',
          align: 'left',
          field: row => row.photo,
          sortable: true
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0
      },
      photos: null,
      photosExpanded: false,
      mainFilesGroup: null,

      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    filesGroupToCheckForIgnoreDuplicate: function () {
      return this.report.filesGroupsContainers.guiImgFiles.getFilesGroup('other')
    }
  },
  methods: {
    onAddRecord: function () {
      const record = {
        fio: this.user.name,
        uid: this.user.login,
        photo: [],
        time: new Date().getTime(),
        comment: null
      }
      this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerLabel: 'Добавление материала',
        contentComponent: ReportCheckListOutlayRecord,
        contentProps: {
          record: record,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess,
          resultValue: this.resultValue,
          filesGroup: this.getFilesGroup(record),
          serviceObject: this.serviceObject,
          isNewRecord: true
        }
      })
    },
    onEditRecord: function (record) {
      this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerLabel: 'Редактирование материала',
        contentComponent: ReportCheckListOutlayRecord,
        contentProps: {
          record: record,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess,
          resultValue: this.resultValue,
          filesGroup: this.getFilesGroup(record),
          serviceObject: this.serviceObject
        }
      })
    },
    onDeleteRecord: function (record) {
      const filesGroup = this.getFilesGroup(record)
      filesGroup.files.forEach(file => {
        filesGroup.removeFile(file)
      })
      const index = this.resultValue.value.findIndex(rec => rec.time === record.time)
      this.resultValue.value.splice(index, 1)
    },
    getAllPhotos: function () {
      const documents = []
      this.resultValue.value.forEach((rec) => {
        documents.push(...this.getFilesGroup(rec).files)
      })
      return documents
    },
    getFilesGroup: function (record) {
      const filesProperty = 'guiImgFiles'
      const filesGroupsContainer = this.report.filesGroupsContainers[filesProperty]

      const key = `${this.resultValue.uniqueKey}_${record.time}`
      let filesGroup = filesGroupsContainer.getFilesGroup(key)

      if (!filesGroup) {
        filesGroup = new FilesGroup({
          categoryKey: 'checkListOutlayResult',
          key: key,
          props: {
            resultKey: key
          }
        })
        filesGroupsContainer.addFilesGroup(filesGroup)
      }

      return filesGroup
    }
  }
}

